import { render, staticRenderFns } from "./SetTicketMinPrice.vue?vue&type=template&id=1824c760"
import script from "./SetTicketMinPrice.vue?vue&type=script&lang=js"
export * from "./SetTicketMinPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports